import test from './components/test';
import floatingbnr from './components/floatingbnr';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    floatingbnr();
  },
  false
);
